import React, { memo } from 'react';

const Spinner = ({ extraClasses = null }) => {
  return <i className={`fas fa-spinner fa-spin fa-fw ${extraClasses ?? ''}`}></i>;
};

export default memo(Spinner);
